import React from 'react';
import { withIcon } from '../../../../components/withIcon/withIcon.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgProjectsRed = (_a) => {
  var _b = _a, { size, title = "ProjectsRed" } = _b, props = __objRest(_b, ["size", "title"]);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size,
    "data-icon-name": title,
    "aria-label": title,
    role: "presentation"
  }, props), /* @__PURE__ */ React.createElement("path", {
    fill: "#435261",
    d: "M47 29c0-7.168-7.626-13-17-13-9.374 0-17 5.832-17 13s7.626 13 17 13a22.01 22.01 0 003.27-.247l8.283 4.141a.992.992 0 00.973-.043c.294-.183.474-.504.474-.851v-7.64c2.492-2.263 4-5.178 4-8.36z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#2C3C4D",
    d: "M22 2C10.42 2 1 9.626 1 19c0 3.603 1.381 7.038 4 9.96V39a1.003 1.003 0 001 1c.153 0 .306-.035.447-.105l9.33-4.665c2.035.511 4.126.77 6.223.77 11.58 0 21-7.626 21-17 0-9.374-9.42-17-21-17z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#EA5B70",
    d: "M32.386 20.897L24.9 26.334 19.394 18.9a4.488 4.488 0 011.02-6.491 4.486 4.486 0 016.4 1.487 4.487 4.487 0 115.572 6.999v.003z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "white",
    d: "M13.026 11.88l.82 9.931-1.356.207-2.176-9.726 2.712-.413zm.904 15.035a1.8 1.8 0 10-.542-3.56 1.8 1.8 0 00.542 3.56z"
  }));
};
var ProjectsRed = withIcon(SvgProjectsRed);

export { ProjectsRed as default };
//# sourceMappingURL=ProjectsRed.es.js.map
